import { createContext } from "react";

import type { SessionMembership, SessionMembershipRole, SessionOrgUnit } from "./types";

export interface SessionData {
  activeOrgUnit: SessionOrgUnit | null;
  memberships: readonly SessionMembership[];
  availableRoles: SessionMembershipRole[];
  permissions: readonly string[];
}

export interface SessionContextValue {
  session: SessionData | null;
  isLoading: boolean;
  isSwitching: boolean;
  switchOrg: (orgUnitId: string) => Promise<void>;
  refreshSession: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextValue | null>(null);
